export const eventCardProps = Object.freeze({
  event: Object,
  eventColor: String,
  onEventColor: String,
  categoryIcon: String,
  categoryName: String,
  background: String,
  costs: Array,
  isOpen: Boolean,
  taskTree: Function,
  notifyUsers: Function,
  notifiedUsers: Array,
  cancelTask: Function,
  closeAllTasks: Function,
  noTabFocus: Boolean,
})